<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M41 26h-1.76A4.49 4.49 0 0032 20.71 4.46 4.46 0 0028.5 19a4.5 4.5 0 00-3.74 7H23a1 1 0 00-1 1v16a1 1 0 001 1h18a1 1 0 001-1V27a1 1 0 00-1-1zm-1 8h-7v-6h7zm-4.5-13a2.5 2.5 0 010 5H33v-2.5a2.5 2.5 0 012.5-2.5zM26 23.5a2.5 2.5 0 015 0V26h-2.5a2.5 2.5 0 01-2.5-2.5zm5 4.5v6h-7v-6zm-7 8h7v6h-7zm9 6v-6h7v6z"/><path d="M56 16v32H8V16h48m1-3H7a2 2 0 00-2 2v34a2 2 0 002 2h50a2 2 0 002-2V15a2 2 0 00-2-2z"/></svg>